import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { countryOption } from 'src/app/shared/utilities/constants';
import { options } from 'src/app/shared/models/profile/trips';
import { AuthenticationService } from 'src/app/shared/services/authentication/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupService } from '../../service/signup.service';
import { SignupMethodSessionKey, SocialLoginSignupPageCount, signupSubmitType } from '../../auth-constants';
import { AuthConnectService } from '../../service/auth-connect.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ssosignup',
  templateUrl: './ssosignup.component.html',
  styleUrls: ['./ssosignup.component.scss', '../../auth-connect/auth-connect.component.scss']
})
export class SsoSignupComponent implements OnInit,OnDestroy{
  @ViewChild('authForm') ssoForm!: NgForm;
  @ViewChild('userinfoAuthForm') userinfoAuthForm!: NgForm;
  @ViewChild('contactNoForm') contactNoForm!: NgForm;
  @Input() userProfile: any;
  noOfView: number = 2;
  pageCount: number = 1;
  heading!: string;
  subheading1!: string;
  subheading2!: string;
  screenWidth!: number;
  isMobileView: boolean = false;
  agreements: any;
  termsAndConditions!: any;
  privacyPolicy!: any;
  betaTerms!: any;
  isPdfModalVisible: boolean = false;
  pdfSource: any;
  filterOptions: options[] = countryOption;
  page: string = 'ssoSignUp';
  userData!: any;
  provider: any;
  isLoggedIn:boolean = false;
  SignupPageCount:any = SocialLoginSignupPageCount
  subscriptions!:Subscription[]

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthenticationService,
    private readonly signUpService: SignupService,
    private readonly authConnectService: AuthConnectService,
    private cd: ChangeDetectorRef
  ) {}
  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnInit(): void {
    this.checkLandingSignupPage();
    this.provider = localStorage.getItem('ssoSignupFederatedProvider');
    sessionStorage.setItem(SignupMethodSessionKey,this.provider);
    this.route.queryParams.subscribe((queryParams) => {
        if (queryParams['isLoggedIn'])
          this.isLoggedIn = true
    });
    this.SignupPageCount = this.signUpService.getSignupEnum()
  }

  checkLandingSignupPage() {
    this.noOfView = this.signUpService.getProgressBarCount()
    const signupPageSubs = this.signUpService.getSignUpPageCountObservable().subscribe((count:number)=>{
      this.pageCount = count
      this.updateHeadings()
      this.cd.detectChanges()
    })
    const signupSubmitSubs =this.signUpService.getTriggerSubmitObservable().subscribe((signupType:number)=>(signupType===signupSubmitType?.socialLogin)?this.handleSubmit():null)
    // start flow with 1 like email signup
    this.signUpService.setSignUpPageCount(1)
    this.subscriptions=[signupPageSubs,signupSubmitSubs]
  }

  signUpCount(event: number) {
    this.pageCount = event;
    if (this.pageCount === 0) {
      this.router.navigate(['auth/signup']);
    }
    this.updateHeadings();
  }

  updateHeadings() {
    const data = this.authConnectService.setHeadings(this.pageCount)
  }

  handleSubmit() {
    this.ssoForm?.reset();
    sessionStorage.setItem('ssoSignupUserInfo', JSON.stringify(this.userProfile));
    if(this.isLoggedIn)
      this.router.navigate(['/auth/signupredirect'], { queryParams: { userFilledForm: true } });
    else
      this.authService.FederatedAuth(this.provider);
  }

  isForm(){
    if(this.signUpService.showSurvey() && this.pageCount === this.SignupPageCount?.survey)
      return false
    if(this.SignupPageCount?.subtenant)
     return this.pageCount > this.SignupPageCount?.subtenant
    return this.pageCount > this.SignupPageCount?.getting_started
  }

  selectedSubtenant(subtenantId: string): void {
    this.userProfile.subtenant = subtenantId;
    this.signUpService.onContinue(this.userProfile);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((x:any)=>x?.unsubscribe())
  }


}
